import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=35529b1f&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=ts&"
export * from "./BusinessProfile.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=35529b1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35529b1f",
  null
  
)

export default component.exports